import React, { useEffect, useState } from "react";
import "./VendorBooking.css";
import moment from "moment";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ShowAllVendors } from "../../../../context/Slice/RegisterSlice";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;

const VendorBooking = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [Bookings, SetBookings] = useState([]);
  const [FormattedData, SetFormattedData] = useState([]);
  const vendorId = localStorage.getItem("userId");
  const [name, setName]=useState("")
  const [FilteredBookings, setFilteredBookings] = useState([]);


  const vendorRole =
    useSelector((state) => state.RegisterR.vendors?.vendorRole) || []; // ✅ Default to empty array

  const vendor = vendorRole.filter((data) => data.id === vendorId);

  useEffect(() => {
    dispatch(ShowAllVendors());
  }, []);

  useEffect(() => {
    if (vendor.length > 0) {
      // console.log(`${vendor[0].firstName} ${vendor[0].lastName}`)
      setName(`${vendor[0].firstName} ${vendor[0].lastName}`);
    } else {
      setName("N/A");
    }
  }, [vendor]); // Runs only when `vendor` changes
  
  // console.log("Vendor Full Name:", name);

  useEffect(() => {
    const fetchAllBookings = async () => {
      try {
        const token = localStorage.getItem("token");
  
        const [response1, response2] = await Promise.all([
          axios.get(
            `${BASE_URL}/api/v1/CoordinatorManagement/admin/Get-Event-Booking-Management`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
          axios.get(
            `${BASE_URL}/api/v1/CoordinatorManagement/get-Event-Booking-Management`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          ),
        ]);
  
        // Extract data from both responses
        const data1 = response1.data.data.getAllEventBookingManagement || [];
        const data2 = response2.data.data || [];
  
        // Parse `data2` if necessary
        const formattedData2 = data2.map((item) => ({
          ...item,
          data: JSON.parse(item.data), // Convert `data` from string to object
        }));
  
        // Merge both data arrays
        const mergedData = [...data1, ...formattedData2];
  
        // Optional: Sort by client name
        mergedData.sort((a, b) => a.data?.client_Name?.localeCompare(b.data?.client_Name) || 0);
  
      
        // Set the merged data in state
        SetBookings(mergedData);
      } catch (error) {
        console.error("Error fetching bookings:", error);
      }
    };
  
    fetchAllBookings();
  }, []);
  


  // ✅ New useEffect to filter vendors and update `Bookings`
  useEffect(() => {
    if (FormattedData.length > 0 && name) {
      const filteredVendors = FormattedData.filter(
        (vendor) => vendor.data.vendor_Name === name
      );

      // console.log("Filtered Vendors:", filteredVendors);

      const updatedData = filteredVendors.map((data) => data.data);
      SetBookings(updatedData);
    }
  }, [FormattedData, name]); // ✅ Runs only when `FormattedData` or `vendorFullName` changes

  console.log("Bookings:", Bookings);

  useEffect(() => {
    if (name && Bookings) {
      const updatedData = Bookings.filter((data) => data.vendor_Name === name);
      console.log("Filtered Data: ", updatedData);
      setFilteredBookings(updatedData);
    }
  }, [Bookings]); // Runs only when `name` or `Bookings` change
  

  const filteredBookings =
  FilteredBookings &&
  FilteredBookings.filter((event) => {
      const eventNameMatch =
        event.event_Type &&
        event.event_Type.toLowerCase().includes(searchTerm.toLowerCase());
      const guestNameMatch =
        event.guests && event.guests.includes(searchTerm.toLowerCase());
      return eventNameMatch || guestNameMatch;
    });

  const handleConfirmBooking = (booking) => {
    console.log("Confirmed Booking:", booking);
    alert(`Booking for "${booking.Event_Name}" has been confirmed.`);
  };

  const handleRejectBooking = (booking) => {
    console.log("Rejected Booking:", booking);
    alert(`Booking for "${booking.Event_Name}" has been rejected.`);
  };
  const HandleBack = () => {
    console.log("Back button clicked");
    navigate("/vendor-dashboard");
  };

  const token = localStorage.getItem("token"); // Use getItem instead of get

  return (
    <div id="VendorBooking">
      {/* Back Button */}
      <Button
        variant="contained"
        color="secondary"
        onClick={HandleBack}
        sx={{
          position: "absolute",
          top: "20px",
          left: "20px",
          zIndex: 1000,
        }}
      >
        Back
      </Button>
      <div>
        <h2 className="heading">Vendor Bookings</h2>
        <div className="searchField">
          <input
            type="text"
            placeholder="Search by Guest or Event Name"
            className="searchInput"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
      <div className="table-container">
        <table className="vendor-booking-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Event Name</th>
              <th>Service Name</th>
              <th>Guest</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Payment Date</th>
              <th>Total Amount</th>

              <th>Advance</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredBookings.length > 0 ? (
              filteredBookings.map((booking, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{booking.event_Type}</td>
                  <td>{booking.vendor_Category}</td>
                  <td>{booking.guests}</td>
                  <td>{moment(booking.start_Date).format("DD/MM/YYYY")}</td>
                  <td>{moment(booking.end_Date).format("DD/MM/YYYY")}</td>
                  <td>{moment(booking.payment_date).format("DD/MM/YYYY")}</td>
                  <td>{booking.total_Amount}</td>
                  <td>{booking.advance_Paid}</td>

                  <td>
                    <div className="action-buttonss">
                      <button
                        className="btn btn-success"
                        onClick={() => handleConfirmBooking(booking)}
                      >
                        ✓
                      </button>
                      <button
                        className="btn btn-danger"
                        onClick={() => handleRejectBooking(booking)}
                      >
                        ✗
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8">No bookings found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VendorBooking;
